export default function LockIcon({ className }) {
  return (
    <svg width="17" height="21" viewBox="0 0 17 21" fill="none" className={className}>
      <path d="M8.58922 0C5.62408 0 3.22245 2.57317 3.22245 5.75011V8.62517H0.539062V20.1254H16.6394V8.62517H13.956V5.75011C13.956 2.57317 11.5544 0 8.58922 0ZM8.58922 2.87506C10.1858 2.87506 11.2726 4.03945 11.2726 5.75011V8.62517H5.90583V5.75011C5.90583 4.03945 6.9926 2.87506 8.58922 2.87506Z" fill="currentColor"/>
    </svg>
  );
}
